<template>
    <div id="help-view">
        <div class="help-menu">
            <div class="logo"><img src="@/assets/logo.png" /></div>
            <div class="help">
                <HelpLink icon="info" link="/help/about">À propos</HelpLink>
                <HelpLink icon="gavel" link="/help/license">Licences</HelpLink>
                <HelpLink icon="book" link="/help/wiki">Wiki</HelpLink>
            </div>
            <MenuLink></MenuLink>
        </div>
        <div class="help-content"><slot></slot></div>
    </div>
</template>

<script>
import HelpLink from '@/components/HelpLink';
import { authenticationService } from '@/services';
import MenuLink from '@/layouts/Menu.vue';

export default {
    data() {
        return {
            user: authenticationService.currentUserValue,
        };
    },
    components: {
        HelpLink,
        MenuLink,
    },
};
</script>

<style lang="scss">
$menu-width: 240px;

#help-view {
    display: flex;
    flex-direction: row;

    .help-content {
        width: 100vw;
        height: 100vh;
        background-color: #f8f8f8;
        overflow: scroll;
    }

    .help-menu {
        width: $menu-width;
        background-color: #ffffff;
        display: flex;
        flex: 1;
        flex-direction: column;
        justify-content: flex-start;
        height: 100vh;

        .logo {
            width: $menu-width;
            height: 50px;
            background-color: #6c3e91;
            flex-shrink: 0;
            flex-grow: 0;
            flex-basis: 50px;

            display: flex;
            flex-direction: column;
            justify-content: center;

            > img {
                margin-left: 20px;
                display: block;
                max-width: 115px;
                height: auto;
            }
        }

        .help {
            flex-shrink: 0;
            flex-grow: 0;
            display: flex;
            flex-direction: column;
        }
    }
}

.title {
    color: #151b25;
    margin: 20px 30px;
    font-size: 22px;
    font-weight: 600;
    line-height: 30px;
}
</style>
